import React from 'react';

import _ from 'lodash';
import { Dialog, DialogContent, useTheme } from '@material-ui/core';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import { BsPatchCheckFill, BsExclamationCircleFill } from 'react-icons/bs';
import { BsExclamationTriangleFill } from 'react-icons/bs';

import { useDialog } from 'hooks';
import { DialogActions, Progress } from 'components';
import { call } from 'utils';

import styles from './ResponseDialog.module.scss';

const ResponseDialog = props => {
  const { data: response } = useDialog(props.response, { data: props.response });
  const { palette } = useTheme();

  const loading = !response || !response.status;
  const parseErrors =
    _.get(response, 'data.parseErrors') || _.get(response, 'errorData.parseErrors');

  const success = !loading && !parseErrors && parseInt(response.status / 100) === 2;
  const warning = !!_.get(response, 'data.parseErrors');

  const renderErrorTable = () => {
    if (parseErrors) {
      return (
        <div className={styles.body}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Message</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Error</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {parseErrors.map(it => (
                <TableRow key={it.index}>
                  <TableCell align="center">{it.index + 1}</TableCell>
                  <TableCell>{it.type}</TableCell>
                  <TableCell>{it.error}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      );
    }

    return null;
  };

  const renderContent = () => {
    if (loading) {
      return (
        <div className={styles.loader}>
          <Progress />
          <span>Saving flow...</span>
        </div>
      );
    }

    if (success) {
      return (
        <div className={styles.success}>
          <BsPatchCheckFill style={{ color: palette.success.main }} />
          <span>Flow successfully saved!</span>
        </div>
      );
    }

    const errorMessage = typeof response.error === 'string' ? response.error : null;

    return (
      <div className={styles.error}>
        <div className={styles.header} style={parseErrors ? { marginTop: 16 } : null}>
          {warning ? (
            <>
              <BsExclamationTriangleFill style={{ color: palette.warning.main }} />
              <span>ATTENTION!</span>
            </>
          ) : (
            <>
              <BsExclamationCircleFill style={{ color: palette.error.main }} />
              <span>
                {!parseErrors && errorMessage ? errorMessage : 'Something went wrong!'}
              </span>
            </>
          )}
        </div>

        {renderErrorTable()}
      </div>
    );
  };

  return (
    <Dialog open={!!props.response} classes={{ paper: styles.dialog }}>
      <DialogContent className={styles.content}>{renderContent()}</DialogContent>
      <DialogActions
        actions={
          loading
            ? []
            : [
                {
                  label: success ? 'ok' : warning ? 'continue' : 'close',
                  type: 'submit',
                  onClick: () => call(props.onClose, success || warning),
                },
              ]
        }
      />
    </Dialog>
  );
};

export default ResponseDialog;
